import { createDrawerNavigator } from '@react-navigation/drawer'
import { IS_WEB } from 'constants/platform'
import { RootStack } from 'navigators'
import React from 'react'
import { useWindowDimensions } from 'react-native'

import { useCurrentUser } from 'hooks/useCurrentUser'

const Drawer = createDrawerNavigator()

export const DrawerNavigator = ({ coachOnboardingModalRef }: any) => {
  const dimensions = useWindowDimensions()
  const isLargeScreen = dimensions.width >= 768
  const { meta } = useCurrentUser()

  return (
    <>
      {meta?.loggedIn && meta?.onboardingComplete ? (
        <Drawer.Navigator
          initialRouteName='Root'
          screenOptions={() => {
            return {
              swipeEdgeWidth: 0,
              drawerType: isLargeScreen ? 'permanent' : 'front',
              overlayColor: 'rgba(0, 0, 0, 0.75)',
              headerStatusBarHeight: 100,
              drawerStyle: {
                width: 350,
                marginLeft: !IS_WEB || !isLargeScreen ? -6 : undefined,
              },
            }
          }}
        >
          <Drawer.Screen name='Root' component={RootStack} options={{ headerShown: false }} />
        </Drawer.Navigator>
      ) : (
        <RootStack />
      )}
    </>
  )
}
